<template>
  <div class="candidate signup page">
    <div style="height: 77vh;">
      <div class="container-wrapper">
        <div ref="container" class="chat-container">
          <v-progress-linear v-if="!ready" color="primary" class="ma-0" height="5" indeterminate />
          <div style="flex: 1 1 auto; min-height: 0rem;" />

          <div style="flex 0 0 auto;" v-if="ready">
            <Account
              v-if="promptToggles.accountPrompts.show"
              :user="user"
              @done="promptToggles.namePrompts.show = true"
              @close="$emit('close')"
              @scroll="scrollDown"
            />

            <Name
              v-if="promptToggles.namePrompts.show"
              @done="showNext('identificationPrompts')"
              @close="$emit('close')"
              @scroll="scrollDown"
            />

            <Identification
              v-if="promptToggles.identificationPrompts.show"
              @done="showNext('finalPrompts')"
              @close="$emit('close')"
              @scroll="scrollDown"
            />

            <FinalizeSignup
              v-if="promptToggles.finalPrompts.show"
              @close="$emit('close')"
              @scroll="scrollDown"
            />
          </div>
        </div>
      </div>
    </div>
    <SignupProgressBar :steps="promptToggles" />
  </div>
</template>

<script>
// Components
import Account from '@/components/prompts/Account'
import Name from '@/components/prompts/Name'
import Identification from '@/components/prompts/Identification'
import FinalizeSignup from '@/components/prompts/FinalizeSignup'
import SignupProgressBar from '@/components/candidate/signup/SignupProgressBar'

// Helpers
import { mapGetters } from 'vuex'
import StayDown from 'staydown'

// Vue Component
export default {
  components: {
    Account,
    FinalizeSignup,
    Identification,
    Name,
    SignupProgressBar,
  },

  mounted() {
    // Initialise scrolling helper
    this.staydown = new StayDown({ target: this.$refs.container, interval: 100 })
    setTimeout(() => (this.ready = true), 2500)
  },

  data() {
    return {
      profile: {},
      // Toggles
      ready: false,
      promptToggles: {
        accountPrompts: {
          order: 0,
          show: true,
          name: 'Email',
          duration: 0,
        },
        namePrompts: {
          name: 'Name',
          order: 1,
          show: false,
          duration: 1,
        },
        identificationPrompts: {
          name: 'Identification',
          order: 2,
          show: false,
          duration: 1,
        },
        finalPrompts: {
          order: 3,
          show: false,
          name: 'Finish Up',
          duration: 0,
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    done() {
      return !Object.keys(this.promptToggles).some(step => !this.promptToggles[step].show)
    },
  },

  watch: {
    done: function(done) {
      if (done) this.$store.dispatch('candidate/profile/fetch')
    },
  },

  methods: {
    scrollDown() {
      // Enable scrolling, it is disabled when user manually scrolls
      if (this.staydown) this.staydown.intend_down = true
    },

    showNext(prompts) {
      this.scrollDown()
      this.$nextTick(() => (this.promptToggles[prompts].show = true))
    },
  },
}
</script>

<style lang="scss">
.candidate.signup.page {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  .container-wrapper {
    position: absolute;
    height: 64vh;
    width: 100%;
    max-width: 900px;
    top: 42%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media (min-width: 600px) {
      width: 90%;
    }

    .chat-container {
      position: relative;
      height: 100%;
      width: 100%;
      overflow-y: scroll;
      display: flex;
      flex-direction: column;
      margin: auto;

      & > * {
        margin-bottom: 1rem;

        @media (min-width: 600px) {
          margin-bottom: 4rem;
        }
      }
    }
  }
}
</style>
